import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _43d17350 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4d2d9de2 = () => interopDefault(import('../pages/tenantadmin/index.vue' /* webpackChunkName: "pages/tenantadmin/index" */))
const _66326cb7 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _30e9b09d = () => interopDefault(import('../pages/tenantadmin/informations/index.vue' /* webpackChunkName: "pages/tenantadmin/informations/index" */))
const _8435a934 = () => interopDefault(import('../pages/tenantadmin/logview.vue' /* webpackChunkName: "pages/tenantadmin/logview" */))
const _0d32f2b2 = () => interopDefault(import('../pages/tenantadmin/ownerconfig.vue' /* webpackChunkName: "pages/tenantadmin/ownerconfig" */))
const _4322bd18 = () => interopDefault(import('../pages/tenantadmin/qanda.vue' /* webpackChunkName: "pages/tenantadmin/qanda" */))
const _44e2827a = () => interopDefault(import('../pages/tenantadmin/qanda/_id.vue' /* webpackChunkName: "pages/tenantadmin/qanda/_id" */))
const _5784011a = () => interopDefault(import('../pages/tenantadmin/questionlist/index.vue' /* webpackChunkName: "pages/tenantadmin/questionlist/index" */))
const _6754d876 = () => interopDefault(import('../pages/tenantadmin/settings.vue' /* webpackChunkName: "pages/tenantadmin/settings" */))
const _32776fdf = () => interopDefault(import('../pages/tenantadmin/stats/index.vue' /* webpackChunkName: "pages/tenantadmin/stats/index" */))
const _45ac71bf = () => interopDefault(import('../pages/tenantadmin/userlist/index.vue' /* webpackChunkName: "pages/tenantadmin/userlist/index" */))
const _05d82588 = () => interopDefault(import('../pages/user/appconfig.vue' /* webpackChunkName: "pages/user/appconfig" */))
const _6320bde9 = () => interopDefault(import('../pages/user/onetimepass.vue' /* webpackChunkName: "pages/user/onetimepass" */))
const _60280e80 = () => interopDefault(import('../pages/user/qanda.vue' /* webpackChunkName: "pages/user/qanda" */))
const _2681e66b = () => interopDefault(import('../pages/user/qanda/_id.vue' /* webpackChunkName: "pages/user/qanda/_id" */))
const _aa23fbde = () => interopDefault(import('../pages/user/question.vue' /* webpackChunkName: "pages/user/question" */))
const _5263ccb8 = () => interopDefault(import('../pages/user/userconfig.vue' /* webpackChunkName: "pages/user/userconfig" */))
const _d7a68eb0 = () => interopDefault(import('../pages/tenantadmin/informations/register.vue' /* webpackChunkName: "pages/tenantadmin/informations/register" */))
const _582d89ea = () => interopDefault(import('../pages/tenantadmin/questionlist/register.vue' /* webpackChunkName: "pages/tenantadmin/questionlist/register" */))
const _f0146774 = () => interopDefault(import('../pages/tenantadmin/userlist/register.vue' /* webpackChunkName: "pages/tenantadmin/userlist/register" */))
const _ed159376 = () => interopDefault(import('../pages/tenantadmin/informations/_id.vue' /* webpackChunkName: "pages/tenantadmin/informations/_id" */))
const _eae1d816 = () => interopDefault(import('../pages/tenantadmin/questionlist/_qid.vue' /* webpackChunkName: "pages/tenantadmin/questionlist/_qid" */))
const _3c8c67b4 = () => interopDefault(import('../pages/tenantadmin/userlist/_uid.vue' /* webpackChunkName: "pages/tenantadmin/userlist/_uid" */))
const _7a29d039 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login",
    component: _43d17350,
    name: "login"
  }, {
    path: "/tenantadmin",
    component: _4d2d9de2,
    name: "tenantadmin"
  }, {
    path: "/user",
    component: _66326cb7,
    name: "user"
  }, {
    path: "/tenantadmin/informations",
    component: _30e9b09d,
    name: "tenantadmin-informations"
  }, {
    path: "/tenantadmin/logview",
    component: _8435a934,
    name: "tenantadmin-logview"
  }, {
    path: "/tenantadmin/ownerconfig",
    component: _0d32f2b2,
    name: "tenantadmin-ownerconfig"
  }, {
    path: "/tenantadmin/qanda",
    component: _4322bd18,
    name: "tenantadmin-qanda",
    children: [{
      path: ":id?",
      component: _44e2827a,
      name: "tenantadmin-qanda-id"
    }]
  }, {
    path: "/tenantadmin/questionlist",
    component: _5784011a,
    name: "tenantadmin-questionlist"
  }, {
    path: "/tenantadmin/settings",
    component: _6754d876,
    name: "tenantadmin-settings"
  }, {
    path: "/tenantadmin/stats",
    component: _32776fdf,
    name: "tenantadmin-stats"
  }, {
    path: "/tenantadmin/userlist",
    component: _45ac71bf,
    name: "tenantadmin-userlist"
  }, {
    path: "/user/appconfig",
    component: _05d82588,
    name: "user-appconfig"
  }, {
    path: "/user/onetimepass",
    component: _6320bde9,
    name: "user-onetimepass"
  }, {
    path: "/user/qanda",
    component: _60280e80,
    name: "user-qanda",
    children: [{
      path: ":id?",
      component: _2681e66b,
      name: "user-qanda-id"
    }]
  }, {
    path: "/user/question",
    component: _aa23fbde,
    name: "user-question"
  }, {
    path: "/user/userconfig",
    component: _5263ccb8,
    name: "user-userconfig"
  }, {
    path: "/tenantadmin/informations/register",
    component: _d7a68eb0,
    name: "tenantadmin-informations-register"
  }, {
    path: "/tenantadmin/questionlist/register",
    component: _582d89ea,
    name: "tenantadmin-questionlist-register"
  }, {
    path: "/tenantadmin/userlist/register",
    component: _f0146774,
    name: "tenantadmin-userlist-register"
  }, {
    path: "/tenantadmin/informations/:id",
    component: _ed159376,
    name: "tenantadmin-informations-id"
  }, {
    path: "/tenantadmin/questionlist/:qid",
    component: _eae1d816,
    name: "tenantadmin-questionlist-qid"
  }, {
    path: "/tenantadmin/userlist/:uid",
    component: _3c8c67b4,
    name: "tenantadmin-userlist-uid"
  }, {
    path: "/",
    component: _7a29d039,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
